import keycloakService from '@/services/keycloak';

export const state = {
    currentUser: null,
};

export const mutations = {
    SET_CURRENT_USER(state, user) {
        state.currentUser = user;
    },
};

export const getters = {
    loggedIn() {
        return keycloakService.isAuthenticated();
    },
    currentUser(state) {
        return state.currentUser;
    },
    userFullName(state) {
        if (!state.currentUser) return '';
        return state.currentUser.fullName ||
               `${state.currentUser.firstName || ''} ${state.currentUser.lastName || ''}`.trim();
    },
    userEmail(state) {
        return state.currentUser?.email || '';
    },
    userInitials(state) {
        if (!state.currentUser) return '?';
        const first = state.currentUser.firstName?.charAt(0) || '';
        const last = state.currentUser.lastName?.charAt(0) || '';
        return (first + last).toUpperCase() || state.currentUser.email?.charAt(0).toUpperCase() || '?';
    },
    hasRole: () => (role) => {
        return keycloakService.hasRole(role);
    },
};

export const actions = {
    init({ commit }) {
        if (keycloakService.isAuthenticated()) {
            const user = keycloakService.getUserProfile();
            commit('SET_CURRENT_USER', user);
        }
    },

    logout() {
        keycloakService.logout();
    },

    refreshUser({ commit }) {
        const user = keycloakService.getUserProfile();
        commit('SET_CURRENT_USER', user);
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions,
};
